import React from 'react';
import PropTypes from 'prop-types';
import InstructionVideoListFilter from './InstructionVideoListFilter';
import InstructionVideoListService from '../services/InstructionVideoListService';
import { observer } from 'mobx-react';

class InstructionVideoListFilterContainer extends React.Component {
  static propTypes = {
    initialFilters: PropTypes.object,
  };

  static defaultProps = {
    initialFilters: null,
  };

  componentDidMount() {
    InstructionVideoListService.init(this.props.initialFilters);
  }

  render() {
    return (
      <InstructionVideoListFilter
        values={InstructionVideoListService.form.getValues()}
        onChange={InstructionVideoListService.form.setValue}
        fetching={InstructionVideoListService.fetch.fetching}
        onSearch={InstructionVideoListService.handleLoad}
      />
    );
  }
}

export default observer(InstructionVideoListFilterContainer);
